<template>
  <page-outline :title="$t('administration.right_add')">
    <template slot="pageContent">
      <b-row class="pb-3 no-gutters">
        <back-button></back-button>
      </b-row>
      <form-accordion :title="$t('administration.right')"  :isTitleUpperCase="false">
        <b-row class="justify-content-start">
          <b-col sm="4" class="form-group" v-for="(right, index) in rights_list" :key="index">
            <b-form-checkbox v-model="rightList[right]"
              :value="1"
              :unchecked-value="0">
              <span>{{ $t('rights.db_rights.' + right) === ('rights.db_rights.' + right) ? right : $t('rights.db_rights.' + right) }}</span>
            </b-form-checkbox>
          </b-col>
        </b-row>
      </form-accordion>
      <b-row class="accordionForm mt-3 justify-content-end form-group p-0 pr-2 no-gutters">
        <b-button variant="primary"
          @click="addRight">
          <i class="fa-light fa-add"></i>
          <span>{{ $t('common.add_label') }}</span>
        </b-button>
      </b-row>
    </template>
  </page-outline>
</template>

<script>
import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'

import {errorMessageAlert} from '@/helpers/alert'
import backButton from "@/components/common/backButton.vue"

import {loadPage} from '@/helpers/routing'

export default {
  name: 'AddAccountMember',
  components: {
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'back-button': backButton,
  },
  props: ['idCompany'],
  data () {
    return {
      allRights: [],
      redirection: this.$engine.company.redirection,
      rightList: {},
      right: '',
      status: '',
      configList: [],
      selectedConfig: {},
      usedConfig: {},
      rights_list: []
    }
  },
  created () {
    this.allRights = this.$engine.rights.getAll()
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: 'Modification de l\'entreprise'
    })

    this.$engine.settings.set({msgDirection: this.direction})
    // this.$bus.$off('refresh-cache-contacts')
    this.atStart(this.idCompany) // modif a check
    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    // this.atStart(false)

    this.filterTypeGet = this.filterType
    this.$bus.$emit('right-panel-set-feature', 'filter-messages')

    let that = this
    let allStatus = Object.keys(this.$engine.rights.getAll()).filter(elem => !this.$engine.company.rightsL.includes(elem))
    let realStatusList = Object.keys(allStatus).filter(elem => allStatus[elem])
    this.rights_list = allStatus
  },
  methods: {
    atStart (val = 1) {
      let that = this
      that.pageCounter = 0
      that.activateSpinner = true
      // this.$engine.company.idCompany = val
      // that.$engine.company.idCompany = val
      that.CompaniesList = []
      let filterConditions = that.$engine.company.getConditionObject()
      filterConditions.sortField = 'SF' + this.sortField
      filterConditions.sortDirection = this.sortDirection
      that.$engine.company.getCompany(
        val,
        10,
        1,
        filterConditions
      ).then(resp => {
        let requests = {}
        if (resp.data && resp.data.company) {
          resp.data.company.idCompany = val
          resp.data.company.identifier = resp.data.company.account.identifier
          resp.data.company.name = resp.data.company.account.name
          resp.data.company.email_reference = resp.data.company.account.email_reference
          resp.data.company.active = resp.data.company.account.active
          resp.data.company.rights = resp.data.company.rights
          resp.data.company.profiles.forEach(item => {
            item.id_rights_profile = item.id_rights_profile
            item.libelle = item.libelle
          })
          resp.data.company.users.forEach(item => {
            item.id_user_account = item.id_user_account
            item.login = item.login
          })
          requests = resp.data.company
          that.CompaniesList.push(requests)
          that.$f7.pullToRefreshDone()
          that.$bus.$emit('refresh-cache-paging-template', this.paginationObject)
        }
        that.activateSpinner = false
      }).catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    addRight () {
      let that = this
      Object.keys(this.rightList).forEach(right => {
        if (that.rightList[right] === 0) {
          delete that.rightList[right]
        }
      })
      this.CompaniesList[0].account.id = this.idCompany
      let acc = this.CompaniesList[0].account
      let newRights = (this.CompaniesList[0].rights).concat(Object.keys(that.rightList))
      if (!Object.keys(that.rightList).length) {
        let that = this
        that.$f7.modal({
          title: this.$i18n.t('Impossible d\'ajouter le droit'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
      } else {
      this.$f7.showPreloader(this.$t('administration.right_adding'))
      that.$engine.company.addRightToAccount(this.idCompany, acc, newRights)
      .then(response => {
            if(response.status === 200)  {
              that.$f7.hidePreloader()
              that.$f7.alert('', that.$t('administration.right_added'))
              loadPage(that, {url: '/company/' + that.redirection})
            }
        })
        .catch(err => {
          errorMessageAlert(e, that)
          that.$f7.modal({
            title: that.$i18n.t('Erreur'),
            buttons: [
              {
                text: 'OK',
                onClick: function () {
                  return
                }
              }
            ]
          })
        })
      }
    }

      /* that.$f7.hidePreloader()
      this.$f7.closeModal()
      that.$f7.alert('Right correctly added', 'Success')
      this.$bus.$emit('refresh-cache-right')
      let that = this */
  }
}
</script>
